import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';

@Component({
    selector: 'input-string',
    templateUrl: './input.string.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputString),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputString implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor {

    value: string;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('type')
    input_type: string;

    @Input('rows')
    rows: number = 1;

    @Input('validator')
    validator: (string) => string; 

    @Input('accept')
    accept: string;

    error: string;

    // control: FormControl;

    constructor(private changer: ChangeDetectorRef) {}

    ngOnInit() {
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngAfterViewInit() {
      this.changer.detectChanges();
    }

    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

    changeValue(event: string) {
      this.value = event;
      this.propagateChange(event);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      this.error = null;
      if (this.required && !event) {
        this.error = 'Value is required';
      } else
      if (this.required && event && event.trim && event.trim().length == 0) {
        this.error = 'Value is required';
      }
    }

    writeValue(value: any) {
      // if (value !== undefined) {
        if (value != this.value) {
          this.changeValue(value);
        }
        this.value = value;
      // }
    }

    propagateChange = (_: string) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}
}